<template>
  <div>
    <Carousel v-model="show" :images="images" />
    <div class="container mx-auto py-10 text-center">
      <button v-for="illustration in illustrations" :key="illustration.img" class="mt-10 first:mt-0">
        <h1 class="tracking-tight font-content md:font-header">
          <span class="block lg:inline text-gray-600 lg:text-black text-sm md:text-xl lg:text-4xl tracking-wide" v-text="illustration.type"></span>
          <span class="hidden lg:inline text-4xl px-1">-</span>
          <span class="block lg:inline text-xl md:text-4xl md:-mt-2 lg:text-4xl" v-text="illustration.title"></span>
        </h1>

        <button @click="open(illustration.carousel)" class="focus:outline-none">
          <img class="mt-2 block mx-auto rounded-lg h-56 object-cover shadow hover:shadow-lg hover:border border-teal-200" :src="illustration.min" :alt="illustration.title">
        </button>
      </button>
    </div>
  </div>
</template>

<script>
import Carousel from '@/components/Carousel'

export default {
  components: {
    Carousel,
  },

  data() {
    return {
      show: false,

      images: [],
    };
  },

  methods: {
    open(carousel) {
      this.show = true

      this.images = carousel;
    },
  },

  computed: {
    illustrations() {
      return this.$store.state.illustrations;
    },
  },
}
</script>
